import { Controller } from "@hotwired/stimulus"
import { get } from '../../helpers/request_helpers'

export default class extends Controller {
  static values = { url: String }

  async load() {
    this.element.disabled = true

    try {
      await get(this.urlValue)
    } catch {
      this.element.disabled = false
    }
  }
}
